"use client";

import { useMemo, useState } from "react";
import { useT } from "@/features/i18n/hooks/use-t";
import FAQItemsAccordian from "./FAQItemsAccordian";
import { faqItems } from "./faqData";
import SupportSidebar from "./SupportSidebar";
import type { FAQTopic } from "./faqData";

export default function FAQSection() {
  const [_expandedId, _setExpandedId] = useState<string | undefined>(
    faqItems[0]?.id,
  );
  const [activeTopic, setActiveTopic] = useState<FAQTopic | "all">("all");
  const [searchQuery, setSearchQuery] = useState("");
  const { t } = useT();

  const filteredItems = useMemo(() => {
    return faqItems.filter((item) => {
      const matchesTopic = activeTopic === "all" || item.topic === activeTopic;
      const translatedQuestion = t(item.questionKey);
      const translatedAnswer = t(item.answerKey);
      const matchesSearch =
        !searchQuery ||
        translatedQuestion.toLowerCase().includes(searchQuery.toLowerCase()) ||
        translatedAnswer.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.tags.some((tag) =>
          tag.toLowerCase().includes(searchQuery.toLowerCase()),
        );

      return matchesTopic && matchesSearch;
    });
  }, [activeTopic, searchQuery, t]);

  return (
    <div className="flex w-full justify-between gap-12 pb-10 sm:pb-0">
      {/* Sidebar: Search + Filter */}
      <SupportSidebar
        activeTopic={activeTopic}
        searchQuery={searchQuery}
        setActiveTopic={setActiveTopic}
        setSearchQuery={setSearchQuery}
      />
      {/* FAQ Items (Accordion) */}
      <FAQItemsAccordian filteredItems={filteredItems} />
    </div>
  );
}
